/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api 
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ServerTypeEnum } from './serverTypeEnum';


export interface ServiceProviderRouteMap { 
    id?: string;
    routeId?: string;
    routeName?: string;
    routeNameFriendlyName?: string;
    creatorIdMapped?: string;
    serverType: ServerTypeEnum;
    serverTypeName?: string;
    dateOfMap: Date;
    originalOwnerId?: string;
    originalOwnerName?: string;
}
